/**
 * Altura da faixa única do composer (uma linha de texto, gravação ou preview de áudio).
 * Mantém o mesmo valor em todos os estados para evitar “pulo” visual ao trocar texto ↔ áudio.
 * Valor alinhado ao `MuiInputBase-root` do TextField multiline (1 linha) no tema atual (~65px).
 */
export const COMPOSER_ROW_HEIGHT_PX = 65;
